export const SVG_WIDTH = 732;
export const SVG_HEIGHT = 500;
export const LEFT_BUFFER = 0   ;
export const RIGHT_BUFFER = 0;
export const Y_BUFFER = 0;

export const Y_LINE_COUNT = 5;

// Hover pointer
export const HOVER_POINTER_Y_OFFSET = 12;
export const HOVER_POINTER_WIDTH = 15;

// Radius of the corners for hover box
export const HOVER_BOX_CORNER_RADIUS = 10;
export const HOVER_BOX_Y_OFFSET = 40;
export const HOVER_MAIN_BOX_Y_BUFFER = 50;
export const HOVER_MAIN_BOX_WIDTH = 165;

// Hover text
export const HOVER_TEXT_LINE_HEIGHT = 18;
export const HOVER_GOAL_LINE_LENGTH = 12;

// Key
export const KEY_LENGTH = 70;
export const KEY_TEXT_BUFFER = 15;
export const KEY_ENTRY_TOTAL_LENGTH = 400;
export const KEY_BOTTOM_BUFFER = 48;

// YLINE
export const LABEL_X_BUFFER = 30;
export const LABEL_Y_BUFFER = 10;

export const Y_AXIS_LABEL_BUFFER = 0;

// XAxis
export const X_AXIS_LABEL_BUFFER = 470;
export const X_AXIS_LABEL_SIZE = 2;
export const X_AXIS_POINTS_SIZE = 3;
export const X_AXIS_POINTS_BUFFER = 415;
export const X_AXIS_TICKS_BUFFER = 435;
export const X_AXIS_VALUES_BUFFER = 450;



